import {
  TTS_DEFAULT_SPEECH_LANGUAGE,
  TTS_DEFAULT_STABILITY,
} from '../_constant'
import { type BaseUIState, createPageStore } from '../../_shared/formStore'
import { TTS_DRAFT_STORAGE_KEY } from '../../_shared/formDraft/draftKeys'

import type { DialogueItem, TTSFormValues } from '../_types/form'

// ─── Form 默认值 ───
export const TTS_FORM_DEFAULTS: TTSFormValues = {
  dialogue: [{ text: '', voice: '' }],
  stability: TTS_DEFAULT_STABILITY,
  speech_language: TTS_DEFAULT_SPEECH_LANGUAGE,
}

// ─── Prefs：需要持久化的用户偏好 ───
export interface TTSPrefs {
  advancedExpanded: boolean
}

const TTS_PREFS_DEFAULTS: TTSPrefs = {
  advancedExpanded: false,
}

// ─── UI：瞬态状态，不持久化 ───
export type TTSUI = BaseUIState

const TTS_UI_DEFAULTS: TTSUI = {
  isSubmitting: false,
  isUploading: false,
}

// ─── sanitize ───
function sanitizeDialogue(dialogue: unknown): DialogueItem[] {
  if (!Array.isArray(dialogue) || dialogue.length === 0) {
    return [{ text: '', voice: '' }]
  }
  return dialogue.map((item: any) => ({
    text: typeof item?.text === 'string' ? item.text : '',
    voice: typeof item?.voice === 'string' ? item.voice : '',
  }))
}

// ─── Store 工厂 ───
export const createTTSStore = () =>
  createPageStore<TTSFormValues, TTSPrefs, TTSUI>({
    name: 'TTSStore',
    persistKey: TTS_DRAFT_STORAGE_KEY,
    formDefaults: TTS_FORM_DEFAULTS,
    prefsDefaults: TTS_PREFS_DEFAULTS,
    uiDefaults: TTS_UI_DEFAULTS,
    sanitizeOnLoad(data) {
      return {
        ...TTS_FORM_DEFAULTS,
        ...data,
        dialogue: sanitizeDialogue(data.dialogue),
        stability:
          typeof data.stability === 'number'
            ? data.stability
            : TTS_DEFAULT_STABILITY,
        speech_language:
          typeof data.speech_language === 'string'
            ? data.speech_language
            : TTS_DEFAULT_SPEECH_LANGUAGE,
      }
    },
  })
